// lib/kontakte/weitereAdressen.ts
// #569: Empfängersuche im Verfassen-Fenster — weitere Mailadressen eines Kontakts (kontakt_kanaele,
// #520) als eigene Vorschläge, damit man z. B. die Buchhaltungsadresse einer Firma wählen kann,
// ohne im Kontakt die Standardadresse umzustellen.

export type KanalOwner = 'mieter' | 'eigentuemer' | 'dienstleister';
export const OWNER_TYP: Record<KanalOwner, string> = { mieter: 'Mieter', eigentuemer: 'Eigentümer', dienstleister: 'Dienstleister' };

export interface Vorschlag { id: string; email: string; name: string; typ: string; label?: string | null }
export interface MailKanal { owner_type: KanalOwner; owner_id: string; wert: string; label: string | null; ist_primaer: boolean; sortierung: number }

/**
 * Hängt hinter jeden Vorschlag dessen weitere Adressen (ohne Dubletten). Kanäle von Kontakten, die
 * (noch) nicht in der Liste stehen, kommen ans Ende — mit Namen aus `namen` (owner_id → Name).
 */
export function mitWeiterenAdressen(vorschlaege: readonly Vorschlag[], kanaele: readonly MailKanal[], namen: ReadonlyMap<string, string> = new Map()): Vorschlag[] {
  const sortiert = [...kanaele].sort((a, b) => Number(b.ist_primaer) - Number(a.ist_primaer) || a.sortierung - b.sortierung);
  const raus: Vorschlag[] = [];
  const gesehen = new Set<string>();
  const schluessel = (typ: string, id: string, mail: string) => `${typ}|${id}|${mail.trim().toLowerCase()}`;
  const push = (v: Vorschlag) => { const k = schluessel(v.typ, v.id, v.email); if (!gesehen.has(k)) { gesehen.add(k); raus.push(v); } };
  const verbraucht = new Set<string>();
  for (const v of vorschlaege) {
    push(v);
    const eigene = sortiert.filter((k) => OWNER_TYP[k.owner_type] === v.typ && k.owner_id === v.id);
    for (const k of eigene) { push({ id: v.id, email: k.wert.trim(), name: v.name, typ: v.typ, label: k.label }); verbraucht.add(`${k.owner_type}|${k.owner_id}`); }
  }
  for (const k of sortiert) {
    if (verbraucht.has(`${k.owner_type}|${k.owner_id}`)) continue;
    push({ id: k.owner_id, email: k.wert.trim(), name: namen.get(k.owner_id) ?? k.wert.trim(), typ: OWNER_TYP[k.owner_type], label: k.label });
  }
  return raus;
}
